"use strict";

var _classCallCheck = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TransactionError =
/*#__PURE__*/
function (_Error) {
  _inherits(TransactionError, _Error);

  function TransactionError() {
    var _this;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var dataPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var actual = arguments.length > 3 ? arguments[3] : undefined;
    var expected = arguments.length > 4 ? arguments[4] : undefined;

    _classCallCheck(this, TransactionError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TransactionError).call(this));
    _this.message = message;
    _this.name = 'TransactionError';
    _this.id = id;
    _this.dataPath = dataPath;
    _this.actual = actual;
    _this.expected = expected;
    return _this;
  }

  _createClass(TransactionError, [{
    key: "toString",
    value: function toString() {
      var defaultMessage = "Transaction: ".concat(this.id, " failed at ").concat(this.dataPath, ": ").concat(this.message);
      var withActual = this.actual ? "".concat(defaultMessage, ", actual: ").concat(this.actual) : defaultMessage;
      var withExpected = this.expected ? "".concat(withActual, ", expected: ").concat(this.expected) : withActual;
      return withExpected;
    }
  }]);

  return TransactionError;
}(_wrapNativeSuper(Error));

exports.TransactionError = TransactionError;

var TransactionPendingError =
/*#__PURE__*/
function (_TransactionError) {
  _inherits(TransactionPendingError, _TransactionError);

  function TransactionPendingError() {
    var _this2;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var dataPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    _classCallCheck(this, TransactionPendingError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(TransactionPendingError).call(this, message));
    _this2.name = 'TransactionPendingError';
    _this2.id = id;
    _this2.dataPath = dataPath;
    return _this2;
  }

  _createClass(TransactionPendingError, [{
    key: "toString",
    value: function toString() {
      return "Transaction: ".concat(this.id, " failed at ").concat(this.dataPath, ": ").concat(this.message, " ");
    }
  }]);

  return TransactionPendingError;
}(TransactionError);

exports.TransactionPendingError = TransactionPendingError;

exports.convertToTransactionError = function (id, errors) {
  if (!errors) {
    return [];
  }

  return errors.map(function (error) {
    return new TransactionError("'".concat(error.dataPath, "' ").concat(error.message), id, error.dataPath);
  });
};

exports.convertToAssetError = function (id, errors) {
  if (!errors) {
    return [];
  }

  return errors.map(function (error) {
    return new TransactionError("'".concat(error.dataPath || '.asset', "' ").concat(error.message), id, error.dataPath || '.asset');
  });
};